module.exports = __webpack_public_path__ + "static/Mewshi.0bd51fbd.png";